// extracted by mini-css-extract-plugin
module.exports = {"separator":"az_Vnb"};